/**
 * User: herbert
 * Date: 13.7.20
 * Time: 17:45
 */

// the whole app is presentation only so we disable jsx-ally
/* eslint jsx-a11y/onclick-has-role: 0 */
/* eslint jsx-a11y/img-has-alt: 0 */

import React from 'react';

import steleActions from '../../actions/stele-actions.js';

import * as config from '../../../../config.js';
import {G_W_45, G_W_85} from "../../../../config";

export default React.createClass({
	propTypes: {
		power: React.PropTypes.string.isRequired,
		type: React.PropTypes.bool.isRequired,
		parentIdx: React.PropTypes.number.isRequired,
		childIdx: React.PropTypes.number.isRequired
	},
	_on45Click: function () {
		if(this.props.type !== config.G_45)
			steleActions.setType(config.G_45, this.props.parentIdx, this.props.childIdx, true);
	},
	_on63Click: function () {
		if(this.props.type !== config.G_63)
			steleActions.setType(config.G_63, this.props.parentIdx, this.props.childIdx, true);
	},
	_on85Click: function () {
		if(this.props.type !== config.G_85)
			steleActions.setType(config.G_85, this.props.parentIdx, this.props.childIdx, true);
	},
	_on135Click: function () {
		if(this.props.type !== config.G_135)
			steleActions.setType(config.G_135, this.props.parentIdx, this.props.childIdx, true);
	},
	_on45WClick: function () {
		if(!this.props.power !== config.G_W_45) {
			steleActions.setPower(G_W_45, this.props.parentIdx, this.props.childIdx);
		}
	},
	_on85WClick: function () {
		if(this.props.power !== config.G_W_85) {
			steleActions.setPower(config.G_W_85, this.props.parentIdx, this.props.childIdx);
		}
	},
	render: function () {
		return (
				<div className="slx-stele-summary__gobo" >
					<div className="slx-stele-summary__optiongroup slx-stele-summary__optiongroup--defaultHeight">
						<div className={this.props.type === config.G_45 ? 'slx-stele-summary__selected' : 'slx-stele-summary__option'} onClick={this._on45Click} >
							<img src="img/stele/parameters/Icon_gobo_45-black.svg"  className="slx-stele-summary__option-img48" />
						</div>
						<div className={this.props.type === config.G_63 ? 'slx-stele-summary__selected' : 'slx-stele-summary__option'} onClick={this._on63Click} >
							<img src="img/stele/parameters/Icon_gobo_63-black.svg" className="slx-stele-summary__option-img48" />
						</div>
						<div className={this.props.type === config.G_85 ? 'slx-stele-summary__selected' : 'slx-stele-summary__option'} onClick={this._on85Click} >
							<img src="img/stele/parameters/Icon_gobo_85-black.svg" className="slx-stele-summary__option-img48" />
						</div>
						<div className={this.props.type === config.G_135 ? 'slx-stele-summary__selected' : 'slx-stele-summary__option'} onClick={this._on135Click} >
							<img src="img/stele/parameters/Icon_gobo_135-black.svg" className="slx-stele-summary__option-img48" />
						</div>
					</div>

					<div className="slx-stele-summary__optiongroup slx-stele-summary__optiongroup--defaultHeight">
						<div className={this.props.power === G_W_45 ? 'slx-stele-summary__selected' : 'slx-stele-summary__option'} onClick={this._on45WClick} >
							<span className="slx-stele-summary__option-text">45&nbsp;W</span>
						</div>
						<div className={this.props.power === G_W_85 ? 'slx-stele-summary__selected' : 'slx-stele-summary__option'} onClick={this._on85WClick} >
							<span className="slx-stele-summary__option-text">85&nbsp;W</span>
						</div>
					</div>
				</div>
		);
	}
});
